import React,{Component} from 'react'
import Select from 'react-select';
import Dialog from '../../../commonModules/interface/Dialog';
import Notif from '../../../commonModules/interface/Notif';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getZoneList } from '../../../../../../jsx/reducers/paygAdmin/zones';
import PopUp from '../../../commonModules/interface/PopUp';
import { Button, Table, TableHead, TableBody, TableRow, TableCell, Grid } from '@material-ui/core';
import InputText from '../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../Stock/containers/Layout';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { toast } from 'react-toastify';

class NewZone extends Component {
    state = {
        zoneName:"",
        zoneCode:"",
        errors:{
            zoneName:"",
            zoneCode:"",
        },
        msg: "",
    }
    componentDidMount= () => {
        if (this.props.ZONE === ""){
            this.props.getZones()
        }
    }

    handleChange = (e) => {
        let value = e.target.value
        let name = e.target.name
        this.setState({
            [name]: value
        })
    }
    
    validate = () => {
        let noErrors = true
        let errors = {}
        const zone = ['zoneName', 'zoneCode']

        zone.map((field)=>{
            if (this.state[field] === "" || !this.state[field] || this.state[field].length === 0 ){
                errors[field] = 'Veuillez remplir ce champ'
                noErrors = false
            } else {
                errors[field]= ''
            }
        })
        this.setState({...this.state,errors})
        console.log("VALIDATE",{noErrors, errors});
        
        return noErrors
    }
    handleSubmit = async () => {
        if(this.validate()){

            let data = {} 
            
            data.zoneName = this.state.zoneName
            data.zoneCode = this.state.zoneCode
            try {
                let req = await fetch('/agent/zone/new',{
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify(data),
                    credentials: 'same-origin',
            
                })
                const res = await req.json()
                console.log({res});
                if((res === "OK")){
                    toast.success( "Nouvelle zone enregistrée" )
                    this.clearForms()
                    this.props.onUpdate()
                } else {
                    toast.error(  res.content)
                    
                }
            } catch (error) {
                toast.error(  error)
            }
           
        } else {
            toast.error("Le formulaire contient des erreurs")
        }
    }

    clearForms = () => {
        this.setState({
            zoneName:"",
            zoneCode:"",
            errors:{
                zoneName:"",
                zoneCode:"",
            },
        })
    }
    render(){
        const { ZONE } = this.props;

        console.log("[STATE] paygo new User", this.state, this.state.zoneList, " - ",ZONE);
        
        return(
            <PopUp
                title="Créer une Zone"
                close={this.props.onClose }
                maxWidth="md"
            >
                {this.state.newZone &&
                    <Dialog 
                        title="Ajouter une Zone"
                        block={true}
                        close={() => this.setState({newZone: false}) }
                        submitAction={this.handleSubmit}
                        submitTitle={"Créer une Zone"}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <InputText 
                                    id="zoneCode" 
                                    onChange={this.handleChange} 
                                    value={this.state.zoneCode} 
                                    name="zoneCode"
                                    label="Code Zone"
                                    required
                                    error={this.state.errors.zoneCode}
                                />
                            </Grid>
                        
                            <Grid item xs={12}>
                                <InputText 
                                    id="zoneName"
                                    onChange={this.handleChange} 
                                    value={this.state.zoneName} 
                                    name="zoneName" 
                                    label="Nom Zone"
                                    required
                                    error={this.state.errors.zoneName}
                                />
                            </Grid>                       
                        </Grid>
                    </Dialog>
                }
                <MiniCard
                    title="Liste des Zones"
                    action={
                        <Button 
                            color="primary" 
                            variant="contained"
                            onClick={() => this.setState({ newZone: true })} 
                        >
                            Nouvelle Zone
                        </Button>
                    }
                >                    
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell>CODE ZONE</TableCell>
                                <TableCell>Nom Zone</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {ZONE && ZONE.map( zone => (
                                <TableRow>
                                    <TableCell>{zone.zone_code}</TableCell>
                                    <TableCell>{zone.zone_name} </TableCell>
                                </TableRow>
                            ))}                                    
                        </TableBody>
                    </TableLayout>
                </MiniCard>
            </PopUp>
                        
        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        ZONE: state.zones
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        getZones: getZoneList,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(NewZone)
